import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        user: '', 
        user_slug: {},
        market:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false,
        page_title:''
      }
  },
  computed: {
    total() {
      var total = 0;
      for(var i = 0; i < this.items.length; i++) {
        total += this.items[i].product_price;
      }
      return total;
    }
},
methods: {
    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    setMarketRemote(){
        service.getBusinessByUserName(this, service.market_app_name).then(response => {
            if(response.body.status == 200) {
                this.market = response.body.data;
            }
        }).catch((err) => {
            //maybe no connection ..load from local
           // this.setSellpointLocal(); //removed...caused slower loading
        })
        
    },


    setMarketLocal(){},

    
  },
  created: function() {
    this.checkLoggedIn();
    this.page_title =this.$route.params.id || this.$route.name;
    
    // this.setMarketRemote();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js